// extracted by mini-css-extract-plugin
export default {"wrapper":"cLs5D42LxxHmOIJSQwTA","period":"n27POtQuloapkkWbBJbr"};